import React, { ReactNode } from 'react';
import SettingsContext, {SettingsContextType} from './context';

type SettingsProviderProps = {
    children: ReactNode;
};
const SettingsProvider: React.FC<SettingsProviderProps> = ({ children }) => {
    // @ts-ignore
    const settings: SettingsContextType = {
        ...window.EMPRIVA_CONDOLEANCEREGISTER_SETTINGS || {},
    };

    settings.debugMode && console.log('settings', settings);

    return (
        <SettingsContext.Provider value={settings}>
            {children}
        </SettingsContext.Provider>
    );
};

export default SettingsProvider;
